module.exports = __webpack_public_path__ + "static/media/Logo__EchoAR.0d1faaa9.svg";